// API 설정
const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const ENV_UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;
const isLocalhostUrl = typeof ENV_UPLOADS_URL === 'string' && /^(https?:)\/\/(localhost|127\.0\.0\.1)(:\\d+)?/i.test(ENV_UPLOADS_URL);

const API_CONFIG = {
  // 프로덕션에서는 같은 도메인, 개발에서는 localhost:5001 사용
  baseURL: process.env.REACT_APP_API_URL || (IS_PRODUCTION ? '' : 'http://localhost:5001'),
  apiURL: process.env.REACT_APP_API_BASE_URL || (IS_PRODUCTION ? '/api' : 'http://localhost:5001/api'),
  // 프로덕션에서 환경변수가 localhost를 가리키면 무시하고 same-origin 사용
  uploadsURL: IS_PRODUCTION
    ? (isLocalhostUrl ? '/api/uploads' : (ENV_UPLOADS_URL || '/api/uploads'))
    : (ENV_UPLOADS_URL || 'http://localhost:5001/api/uploads')
};

// 이미지 URL 생성 유틸리티 함수
export const getImageUrl = (imagePath: string): string => {
  // 개발 환경에서는 로컬 public 폴더 사용, 프로덕션에서는 백엔드 API 사용
  if (process.env.NODE_ENV === 'production') {
    // 이미지 경로에서 'images/' 제거 (이미 포함된 경우)
    const cleanPath = imagePath.replace(/^images\//, '');
    return `${API_CONFIG.uploadsURL}/images/${cleanPath}`;
  } else {
    // 개발 환경에서는 public 폴더의 이미지 사용
    const cleanPath = imagePath.replace(/^images\//, '');
    return `/images/${cleanPath}`;
  }
};

// API 엔드포인트 생성 유틸리티 함수
export const getApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.replace(/^\//, '');
  return `${API_CONFIG.apiURL}/${cleanEndpoint}`;
};

export default API_CONFIG;